var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlovakia = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EE1C25",
  d: "M0 0h32v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B4EA2",
  d: "M0 0h32v16H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v8H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.65 18.54c-2.15-1.035-5.23-3.095-5.23-7.16 0-4.07.2-5.92.2-5.92h10.066s.195 1.85.195 5.92-3.08 6.12-5.23 7.16Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE1C25",
  d: "M11.65 18c-1.974-.95-4.8-2.84-4.8-6.57S7.03 6 7.03 6h9.24s.176 1.7.176 5.43c.005 3.735-2.82 5.62-4.795 6.57Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.07 10.45c.535.01 1.58.03 2.505-.28 0 0-.02.335-.02.72s.025.72.025.72c-.85-.285-1.905-.29-2.51-.285v2.06h-.84v-2.06c-.6-.005-1.655 0-2.505.285 0 0 .025-.335.025-.72 0-.39-.025-.72-.025-.72.925.31 1.97.29 2.5.28V9.155c-.485 0-1.185.02-1.98.285 0 0 .025-.33.025-.72 0-.385-.025-.72-.025-.72.795.265 1.495.29 1.98.285-.025-.82-.265-1.85-.265-1.85s.495.035.69.035c.2 0 .69-.035.69-.035s-.24 1.03-.265 1.85A5.9 5.9 0 0 0 14.055 8s-.025.335-.025.72c0 .39.025.72.025.72a6 6 0 0 0-1.985-.285v1.3z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B4EA2",
  d: "M11.65 13.165c-.994 0-1.524 1.375-1.524 1.375s-.3-.65-1.11-.65c-.55 0-.95.485-1.21.94 1 1.585 2.595 2.565 3.845 3.17 1.25-.6 2.85-1.585 3.845-3.17-.26-.45-.66-.94-1.21-.94-.81 0-1.11.65-1.11.65s-.525-1.375-1.525-1.375Z"
})));
export default SvgSlovakia;